import { MarketTypeName, SelectionOutcomeType } from './sportsbook-types';

export const REDUCER_NAME = 'sportsbookLobby';
export const ACTION_PREFIX = '@komigen/sportsbookLobby/';
export const GENERIC_ACTION = `${ACTION_PREFIX}GENERIC`;

export const TAB_LIVE_ROUTE = 'live';
export const TAB_UPCOMING_ROUTE = 'upcoming';
export const TAB_STARTING_SOON_ROUTE = 'starting-soon';
export const TAB_LEAGUES_ROUTE = 'leagues';
export const TAB_OUTRIGHTS_ROUTE = 'outrights';
export const TAB_TOURNAMENT_PREVIEW = 'tournament-preview';
export const TAB_OPEN_BETS_ROUTE = 'open';
export const TAB_SETTLED_BETS_ROUTE = 'settled';

export const TAB_EVENT_OPEN_BETS_ROUTE = 'open-bets';
export const TAB_EVENT_BET_BUILDER_ROUTE = 'bet-builder';

export const MARKET_NAME_1X2 = '1X2';
export const MARKET_NAME_WINNER = 'Winner';
export const MARKET_NAME_SPREAD = 'Spread';
export const MARKET_NAME_MONEYLINE = 'Moneyline';
export const MARKET_NAME_WINNER_INCLUDING_OVERTIME = 'Winner (incl. overtime)';
export const MARKET_NAME_WINNER_INCLUDING_EXTRA_INNINGS = 'Winner (incl. extra innings)';
export const MARKET_NAME_WINNER_INCLUDING_SUPER_OVER = 'Winner (incl. super over)';

export const MARKET_TYPE_ID_1X2 = 'a_1';
export const MARKET_TYPE_ID_1X2_LIVE = 'a_1';
export const MARKET_TYPE_ID_WINNER = 'a_175';
export const MARKET_TYPE_ID_WINNER_LIVE = 'a_175';
export const MARKET_TYPE_ID_WINNER_INCLUDING_OVERTIME = 'a_206';
export const MARKET_TYPE_ID_WINNER_INCLUDING_EXTRA_INNINGS = 'a_232';
export const MARKET_TYPE_ID_WINNER_INCLUDING_SUPER_OVER = 'a_314';
export const MARKET_TYPE_ID_SPREAD = '2_0';
export const MARKET_TYPE_ID_SPREAD_LIVE = '2_39';
export const MARKET_TYPE_ID_HALFTIME_FULLTIME = '62';
export const MARKET_TYPE_ID_NUMBER_OF_TEAM_GOALS = '154';
export const MARKET_TYPE_ID_OU = '3_0';
export const MARKET_TYPE_ID_OU_LIVE = '3_39';
export const MARKET_TYPE_ID_TOTAL_GOALS = '3_200';
export const MARKET_TYPE_ID_TOTAL_GOALS_LIVE = '3_249';
export const MARKET_TYPE_ID_TOTAL_GOALS_FIRST_HALF = '3_201';
export const MARKET_TYPE_ID_EXACT_SCORE = '60';
export const MARKET_TYPE_ID_1X2_FIRST_HALF = '1_1';
export const MARKET_TYPE_ID_1X2_FIRST_GOAL = '235';
export const MARKET_TYPE_ID_1X2_FIRST_GOAL_FIRST_HALF = '2071';
export const MARKET_TYPE_ID_DRAW_NO_BET = '2_157';
export const MARKET_TYPE_ID_DRAW_NO_BET_LIVE = '6432';
export const MARKET_TYPE_ID_LAST_GOAL_LIVE = '6092';
export const MARKET_TYPE_ID_TEAM_TO_WIN_EATHER_HALF_LIVE = '704';
export const MARKET_TYPE_ID_GOALSCORER = '76';
export const MARKET_TYPE_ID_GOALSCORER_PREMIER = '702';
export const MARKET_TYPE_ID_SPECIALS = 'a_1038';

export const EVENT_TYPE_FIXTURE = 'Fixture';
export const EVENT_TYPE_OUTRIGHT = 'Outright';
export const EVENT_TYPE_AGGREGATE_FIXTURE = 'AggregateFixture';
export const EVENT_TYPE_ANTE_POST_RACE = 'AntePostRace';
export const EVENT_TYPE_DAY_OF_EVENT_RACE = 'DayOfEventRace';

export const EVENT_TYPE_ALL_FIXTURES = [
	EVENT_TYPE_FIXTURE,
	EVENT_TYPE_AGGREGATE_FIXTURE,
	EVENT_TYPE_ANTE_POST_RACE,
	EVENT_TYPE_DAY_OF_EVENT_RACE
];

export const SPORT_FOOTBALL_ID = '1';
export const SPORT_BASKETBALL_ID = '2';
export const SPORT_AMERICAN_FOOTBALL_ID = '3';
export const SPORT_TENNIS_ID = '6';
export const SPORT_BASEBALL_ID = '7';
export const SPORT_ICE_HOCKEY_ID = '8';
export const SPORT_SPECIALS_ID = '9';
export const SPORT_HANDBALL_ID = '10';
export const SPORT_TABLE_TENNIS_ID = '26';
export const SPORT_CRICKET_ID = '59';
export const SPORT_HORSE_RACING_ID = '61';
export const SPORT_VOLLEYBALL_ID = '19';
export const SPORT_BADMINTON_ID = '34';
export const SPORT_DART_ID = '15';
export const SPORT_RUGBY_ID = '11';
export const SPORT_SNOOKER_ID = '13';
export const SPORT_FUTSAL_ID = '25';
export const SPORT_BOXING_ID = '20';

export const ALL_SPORT_IDS = [
	SPORT_FOOTBALL_ID,
	SPORT_BASKETBALL_ID,
	SPORT_AMERICAN_FOOTBALL_ID,
	SPORT_TENNIS_ID,
	SPORT_BASEBALL_ID,
	SPORT_ICE_HOCKEY_ID,
	SPORT_SPECIALS_ID,
	SPORT_HANDBALL_ID,
	SPORT_TABLE_TENNIS_ID,
	SPORT_HORSE_RACING_ID,
	SPORT_VOLLEYBALL_ID,
	SPORT_BADMINTON_ID,
	SPORT_DART_ID,
	SPORT_RUGBY_ID,
	SPORT_SNOOKER_ID,
	SPORT_FUTSAL_ID
];

export const SPORTS_IDS_WITH_SETS_SCORE = [SPORT_TENNIS_ID, SPORT_TABLE_TENNIS_ID];

export const ParticipantVenueRole = {
	HOME: 'Home',
	AWAY: 'Away'
} as const;

export const SELECTION_OUTCOME_TYPE_SORT_MAP_DEFAULT = 'DEFAULT';

export const SelectionOutcomeTypeSortMap: { [key: string | SelectionOutcomeType]: number } = {
	// Home tie away
	[SelectionOutcomeType.HOME]: 0,
	[SelectionOutcomeType.TIE]: 1,
	[SelectionOutcomeType.AWAY]: 2,
	// OU
	[SelectionOutcomeType.UNDER]: 3,
	[SelectionOutcomeType.OVER]: 4,
	// Yes No
	[SelectionOutcomeType.YES]: 5,
	[SelectionOutcomeType.NO]: 6,
	// Goalscorer
	[SelectionOutcomeType.TO_SCORE_FIRST]: 7,
	[SelectionOutcomeType.TO_SCORE_LAST]: 8,
	[SelectionOutcomeType.TO_SCORE_ANYTIME]: 9,
	[SelectionOutcomeType.TO_SCORE_FIRST_OR_LAST]: 10,
	[SelectionOutcomeType.TO_SCORE_20_MORE]: 11,
	[SelectionOutcomeType.TO_SCORE_30_MORE]: 12,

	// Default = last
	[SELECTION_OUTCOME_TYPE_SORT_MAP_DEFAULT]: 9999
};

export const SELECTION_OUTCOME_TYPE_DEFAULT = 'DEFAULT';
export const MARKET_OUTCOME_TYPE_DEFAULT = 'DEFAULT';

export const MarketWinnerOutcomeTypeMap: { [key: string]: number } = {
	[SelectionOutcomeType.HOME]: 1,
	[SelectionOutcomeType.AWAY]: 2,

	// Default to last column
	[SELECTION_OUTCOME_TYPE_DEFAULT]: 0
};

export const Market1X2OutcomeTypeMap: { [key: string]: number } = {
	[SelectionOutcomeType.HOME]: 1,
	[SelectionOutcomeType.TIE]: 2,
	[SelectionOutcomeType.AWAY]: 3,
	// Default to last column
	[SELECTION_OUTCOME_TYPE_DEFAULT]: 4
};

export const MarketOutcomeTypeMap = {
	[MarketTypeName.NAME_WINNER]: MarketWinnerOutcomeTypeMap,
	[MarketTypeName.NAME_1X2]: Market1X2OutcomeTypeMap,
	[MARKET_OUTCOME_TYPE_DEFAULT]: undefined
};

export const SettlementStatus = {
	OPEN: 'OPEN',
	WON: 'WON',
	LOST: 'LOST',
	CANCELLED: 'CANCELLED',
	CASHOUT: 'CASHOUT'
};

export const BetStatus = {
	SETTLED: 'SETTLED',
	UNSETTLED: 'UNSETTLED'
};

export const SelectionStatus = {
	ACTIVE: 'Active',
	DISABLED: 'Disabled',
	NON_RUNNER: 'NonRunner'
};

export const EventType = {
	OUTRIGHT: 'Outright',
	FIXTURE: 'Fixture'
};

export const MARKET_VERTICAL_LAYOUT_ID = 'MARKET_VERTICAL_LAYOUT_ID';
export const MARKET_HORIZONTAL_LAYOUT_ID = 'MARKET_HORIZONTAL_LAYOUT_ID';
export const MARKET_TABLE_LAYOUT_ID = 'MARKET_TABLE_LAYOUT_ID';
export const MARKET_FLOATING_LAYOUT_ID = 'MARKET_FLOATING_LAYOUT_ID';
export const MARKET_GROUP_ID_ALL_MARKETS = 'ALL_MARKETS';

export const PromotionTypes = {
	SINGLE: 'Single',
	COMBO: 'Combo',
	LINK: 'Link'
};

export const RoundingMode = {
	CEILING: 'Ceiling',
	FLOOR: 'Floor',
	ROUND: 'Round'
};

export const MarketTypeIdsBySport: {
	[key: string]: string[];
} = {
	[SPORT_FOOTBALL_ID]: [MARKET_TYPE_ID_1X2, MARKET_TYPE_ID_1X2_LIVE],
	[SPORT_TENNIS_ID]: [MARKET_TYPE_ID_WINNER, MARKET_TYPE_ID_WINNER_LIVE],
	[SPORT_BASKETBALL_ID]: [MARKET_TYPE_ID_WINNER, MARKET_TYPE_ID_WINNER_LIVE]
};

export const SPORTSBOOK_PORTAL_ID = 'sportsbook-portal-root';

export enum StaleTime {
	ZERO = 0, // Should be used as default for all requests (Always fresh data on demand).
	// Uncomment and use others only if you know what you are doing.
	THIRTY_SECONDS = 30 * 1000, // 30 seconds
	SHORT = 60 * 1000, // 1 minute
	MODERATE = 5 * 60 * 1000, // 5 minutes
	LONG = 15 * 60 * 1000, // 15 minutes
	INFINITE = Infinity // Never expires
}

export enum RefetchInterval {
	SHORT = 60 * 1000, // 1 minute
	MODERATE = 5 * 60 * 1000, // 5 minutes
	LONG = 15 * 60 * 1000 // 15 minutes
}
